import React, { useMemo } from 'react';
import {
  AppButton,
  Box,
  Inscription,
  RoundDoneIcon,
} from '@common-fe/common-fe';

import { ModalWrapper } from '@/components/wrappers';

import { useCancelEmployerTerminationSuccessModalStore,useEmployerTerminationModalStore } from './store';

export const CancelEmployerTerminationSuccessModal = () => {
  const modalVisible = useCancelEmployerTerminationSuccessModalStore((state) => state.modalVisible);
  const handleChangeVisibility = useCancelEmployerTerminationSuccessModalStore((state) => state.handleChangeVisibility);

  const employerName = useEmployerTerminationModalStore((state) => state.employerName);
  const handleReset = useEmployerTerminationModalStore((state) => state.handleReset);
  const additionalAction = useEmployerTerminationModalStore((state) => state.additionalAction);

  const headerText = useMemo(() => `Termination canceled for ${employerName}`,[employerName]);

  const onSubmit = () => {
    handleChangeVisibility(false);
    additionalAction?.();
    handleReset();
  };
  return (
    <ModalWrapper testId="CancelEmployerTerminationSuccessModal" visible={modalVisible} onSetVisible={onSubmit}>
      <Box align="center" pad={{ vertical: 'spacing24', horizontal: 'spacing24' }}>
        <RoundDoneIcon />
        <Inscription
          data-testid="CancelEmployerTerminationSuccessModal_header"
          margin={{ top: 'spacing12', bottom: 'spacing24' }}
          textAlign="center"
          size="24px"
          weight={700}
          lineHeight="32px"
        >
          {headerText}
        </Inscription>

        <AppButton
          testId="CancelEmployerTerminationSuccessModal"
          onClick={onSubmit}
          width="200px"
        >
          Got It!
        </AppButton>
      </Box>
    </ModalWrapper>
  );
};